// @flow
import React from 'react';
import styles from './BackButton.css';
import classnames from 'classnames';
import IconLabel from '../util/IconLabel';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { commonMessages } from '../messages/Common';
type OwnProps = {
  isActive?: boolean,
  isVisible: boolean,
  onClick: Function,
};

type Props = OwnProps & {
  intl: IntlShape,
};

const BackButton = ({ isActive, isVisible, onClick, intl }: Props) => {
  if (!isVisible) {
    return null;
  }

  const classIcon = 'c-icon--label-false';
  const arrowLeftClasses = classnames(classIcon, {
    'is-active': isActive,
  });

  return (
    <div className={styles.wrapper}>
      <button
        className={styles.button}
        onClick={onClick}
        aria-label={intl.formatMessage(commonMessages.back)}
        data-test="back-button"
      >
        <IconLabel name="chevron-left" className={arrowLeftClasses} />
      </button>
    </div>
  );
};

export default injectIntl(BackButton);
